import { useMemo } from 'react';
import type { State, User } from './types';
import { caseInsensitiveSort } from '@/lib/sort';

function allUsersList(users: Record<string, User>) {
  return Object.values(users).sort(caseInsensitiveSort('data.displayName'));
}

function activeUsersList(users: Record<string, User>) {
  return allUsersList(users).filter(
    (user) => !user.data.archived && user.data.active,
  );
}

function inactiveUsersList(users: Record<string, User>) {
  return allUsersList(users).filter(
    (user) => !user.data.archived && !user.data.active,
  );
}

function archivedUsersList(users: Record<string, User>) {
  return allUsersList(users).filter((user) => {
    return user.data.archived;
  });
}

function unarchivedUsersList(users: Record<string, User>) {
  return allUsersList(users).filter((user) => !user.data.archived);
}

export function useComputed(state: State) {
  return {
    usersList: useMemo(() => allUsersList(state.users), [state.users]),
    activeUsersList: useMemo(() => activeUsersList(state.users), [state.users]),
    inactiveUsersList: useMemo(
      () => inactiveUsersList(state.users),
      [state.users],
    ),
    archivedUsersList: useMemo(
      () => archivedUsersList(state.users),
      [state.users],
    ),
    unarchivedUsersList: useMemo(
      () => unarchivedUsersList(state.users),
      [state.users],
    ),
  };
}

export type Computed = ReturnType<typeof useComputed>;
